import React, { useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Navbar from "../../../components/Navbar";
import Footer from "../../../components/Footer";
import { ProgramProvider } from "./ProgramContext";
import ProgramPage from "./ProgramPage";
import { LanguageProvider } from "../../../components/LanguageContext";
import { OverflowContainer } from "../../Home/HomeElements";
import { animateScroll as scroll } from "react-scroll";
const ProgramProp = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  scroll.scrollToTop();
  return (
    <LanguageProvider>
      <ProgramProvider>
        <Sidebar isOpen={isOpen} toggle={toggle}></Sidebar>
        <Navbar toggle={toggle}></Navbar>{" "}
        <OverflowContainer>
          <ProgramPage></ProgramPage>
        </OverflowContainer>
        <Footer></Footer>
      </ProgramProvider>
    </LanguageProvider>
  );
};

export default ProgramProp;
